module.exports = __webpack_public_path__ + "img/logo-mini.c949e51e.svg";